import { dayOf, describe } from '../../dates';
import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// One invitation not answered yet, in the Patients list under Invited: the
// name the clinician gave it, or the address, and when it was sent.
export function InvitedRow({ invitation }) {
  const { text, language } = useLanguage();
  const { email, name, sentAt } = invitation;
  let who = email;
  let address = null;

  if (name != null) {
    who = name;
    address = <span className={ styles.detail }>{ email }</span>;
  }

  return (
    <div className={ styles.row }>
      <span className={ styles.lines }>
        <span className={ styles.name }>{ who }</span>

        { address }

        <span className={ styles.detail }>{ text.invitedNotAnswered.replace('{date}', describe({ day: dayOf(sentAt), language, short: true })) }</span>
      </span>
    </div>
  );
}
